// @flow
import React from 'react';

import {
  BottomNavigation,
  BottomNavigationItem,
} from 'material-ui/BottomNavigation';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import FontIcon from 'material-ui/FontIcon';
import Paper from 'material-ui/Paper';

import SavedTemplatesPopover from './SavedTemplatesPopover';
import { isFeatureDisabled } from '../../utils/auth';

const getStyles = ({
  appInDrawMode,
  isMobile,
  drawOverlayHasFeature,
  hasSubscription,
}) => ({
  container: {
    position: 'fixed',
    bottom: appInDrawMode ? 0 : -64,
    width: '100vw',
    zIndex: 1400,
  },

  clearButton: {
    opacity: drawOverlayHasFeature ? 1 : 0.25,
  },

  toolbarItem:
    hasSubscription && isMobile
      ? {
          width: 60,
          minWidth: 60,
          fontSize: '.9em',
          padding: '0 !important',
        }
      : {},

  toolbarItemDisabled:
    {
          width: 60,
          minWidth: 60,
          fontSize: '.9em',
          padding: '0 !important',
          cursor: 'not-allowed',
          opacity: 0.5,
    },

  fab: {
    position: 'fixed',
    bottom: 80,
    right: 12,
    ...(drawOverlayHasFeature
      ? {}
      : { boxShadow: '0 0 5px rgba(0, 0, 0, .25)' }),
  },

  fabSecondary: {
    position: 'fixed',
    bottom: 160,
    right: 12,
    ...(drawOverlayHasFeature
      ? {}
      : { boxShadow: '0 0 5px rgba(0, 0, 0, .25)' }),
  },
});

export default ({
  hasSubscription,
  browser,

  appInDrawMode,
  dndState,

  drawOverlayMode,
  drawOverlayHasFeature,

  setDrawOverlayMode,
  clearDrawOverlay,

  toggleDrawMode,
  toggleCoordinateInputDialog,

  dndOverlaySetDndState,
  dndOverlaySetButtonVisible,

  requestAnalysis,
}: any) => {
  const showItem = item => ('show' in item ? item.show : true);
  const isMobile = browser.lessThan.medium;
  const styles = getStyles({
    appInDrawMode,
    drawOverlayHasFeature,
    hasSubscription,
    isMobile,
  });

  const ITEMS = [
    {
      id: 'polygon',
      label: 'Sokszög',
      shortLabel: 'Sokszög',
      icon: 'crop_square',
      onClick: () => setDrawOverlayMode('draw_polygon'),
      feature: 'mark_area',
    },
    {
      id: 'circle',
      label: 'Kör',
      shortLabel: 'Kör',
      icon: 'panorama_fish_eye',
      onClick: () => setDrawOverlayMode('draw_circle'),
      feature: 'mark_area',
    },
    {
      id: 'coordinates',
      label: 'Koordináták',
      shortLabel: 'Koord.',
      icon: 'format_list_bulleted',
      onClick: () => {
        dndOverlaySetDndState(null);
        setDrawOverlayMode('simple_select');
        toggleCoordinateInputDialog(true);
      },
      feature: 'set_coordinate',
    },
    {
      id: 'kml',
      label: '.KML/.KMZ',
      shortLabel: 'KML',
      icon: 'file_upload',
      tooltip: 'Húzza a böngészőbe a fájlokat a feltöltéshez',
      show: hasSubscription,
      onClick: () => {
        setDrawOverlayMode('simple_select');
        dndOverlaySetButtonVisible(true);
        dndOverlaySetDndState('awaitDrop');
      },
      feature: 'kmz_kml_import',
    },
    {
      id: 'templates',
      show: hasSubscription,
      render: ({ styles }) => (
        <SavedTemplatesPopover
          key="saved-templates-popover"
          style={isFeatureDisabled('saved_templates') ? styles.toolbarItemDisabled : styles.toolbarItem}
        />
      ),
      feature: 'saved_templates',
    },
    {
      id: 'clear',
      label: 'Törlés',
      shortLabel: 'Törlés',
      icon: 'clear',
      style: styles.clearButton,
      onClick: () => {
        dndOverlaySetDndState(null);
        clearDrawOverlay();
      },
      feature: 'enabled',
    },
  ];

  let selectedIndex;

  if (drawOverlayMode === 'draw_polygon') {
    selectedIndex = 0;
  } else if (drawOverlayMode === 'draw_circle') {
    selectedIndex = 1;
  } else if (dndState === 'awaitDrop') {
    selectedIndex = 3;
  }

  return (
    <Paper zDepth={1} style={styles.container}>
      <BottomNavigation selectedIndex={selectedIndex}>
        {ITEMS.map(
          ({ show = true, ...item }) =>
            show &&
            (item.render ? (
              item.render({ styles })
            ) : (
              <BottomNavigationItem
                key={`draw-toolbar-item-${item.id}`}
                className={`draw-tools-tour__step-${item.id}`}
                style={isFeatureDisabled(item.feature) ? styles.toolbarItemDisabled : styles.toolbarItem}
                tooltip={item.tooltip}
                onClick={item.onClick}
                label={isMobile ? item.shortLabel : item.label}
                icon={
                  <FontIcon className="material-icons">{item.icon}</FontIcon>
                }
                disabled={isFeatureDisabled(item.feature)}
              />
            ))
        ).filter(item => item)}
      </BottomNavigation>
      {appInDrawMode && (
        <React.Fragment>
          <FloatingActionButton
            className="draw-tools-tour__step-submit"
            style={styles.fab}
            disabled={!drawOverlayHasFeature}
            onClick={() => {
              toggleDrawMode(false);
              requestAnalysis();
            }}
          >
            <FontIcon className="material-icons">flight_takeoff</FontIcon>
          </FloatingActionButton>
        </React.Fragment>
      )}
    </Paper>
  );
};



// WEBPACK FOOTER //
// ./components/DrawToolbar/DrawToolbar.js